import { EntityTemplateVariables } from '@tools/interfaces/template';
import { getContactFieldsForEntity } from './template-contact';

export const templateMandate: EntityTemplateVariables = {
  fields: [
    {
      label: 'templates.mandates.code.label',
      contentValue: '{{ mandate.code }}',
      description: 'templates.mandates.code.description',
    },
    {
      label: 'templates.mandates.name.label',
      contentValue: '{{ mandate.name }}',
      description: 'templates.mandates.name.description',
    },
    {
      label: 'templates.mandates.bic_number.label',
      contentValue: '{{ mandate.bic_number }}',
      description: 'templates.mandates.bic_number.description',
    },
    {
      label: 'templates.mandates.iban_number.label',
      contentValue: '{{ mandate.iban_number }}',
      description: 'templates.mandates.iban_number.description',
    },
    {
      label: 'templates.mandates.signature_date.label',
      contentValue: '{{ mandate.signature_date | date("d/m/Y") }}',
      description: 'templates.mandates.signature_date.description',
    },
    {
      label: 'templates.mandates.last_direct_debit_date.label',
      contentValue: '{{ mandate.last_direct_debit_date | date("d/m/Y") }}',
      description: 'templates.mandates.last_direct_debit_date.description',
    },
    {
      label: 'templates.mandates.notification_date.label',
      contentValue: '{{ mandate.notification_date | date("d/m/Y") }}',
      description: 'templates.mandates.notification_date.description',
    },
    {
      label: 'templates.mandates.status.label',
      contentValue: '{{ mandate.status }}',
      description: 'templates.mandates.status.description',
    },
    {
      label: 'templates.mandates.settings.sepa_name_of_the_legal_entity.label',
      contentValue: '{{ mandate.center.centerSetting.sepa_name_of_the_legal_entity }}',
      description: 'templates.mandates.settings.sepa_name_of_the_legal_entity.description',
    },
    {
      label: 'templates.mandates.settings.sepa_street.label',
      contentValue: '{{ mandate.center.centerSetting.sepa_street }}',
      description: 'templates.mandates.settings.sepa_street.description',
    },
    {
      label: 'templates.mandates.settings.sepa_street2.label',
      contentValue: '{{ mandate.center.centerSetting.sepa_street2 }}',
      description: 'templates.mandates.settings.sepa_street2.description',
    },
    {
      label: 'templates.mandates.settings.sepa_zip.label',
      contentValue: '{{ mandate.center.centerSetting.sepa_zip }}',
      description: 'templates.mandates.settings.sepa_zip.description',
    },
    {
      label: 'templates.mandates.settings.sepa_city.label',
      contentValue: '{{ mandate.center.centerSetting.sepa_city }}',
      description: 'templates.mandates.settings.sepa_city.description',
    },
    {
      label: 'templates.mandates.settings.sepa_iban_number.label',
      contentValue: '{{ mandate.center.centerSetting.sepa_iban_number }}',
      description: 'templates.mandates.settings.sepa_iban_number.description',
    },
    {
      label: 'templates.mandates.settings.sepa_bic_number.label',
      contentValue: '{{ mandate.center.centerSetting.sepa_bic_number }}',
      description: 'templates.mandates.settings.sepa_bic_number.description',
    },
    {
      label: 'templates.mandates.settings.sepa_identifier.label',
      contentValue: '{{ mandate.center.centerSetting.sepa_identifier }}',
      description: 'templates.mandates.settings.sepa_identifier.description',
    },
  ],
  related: [
    {
      relationName: 'contact',
      relationType: 'simple',
      label: 'templates.mandates.contact.label',
      description: 'templates.mandates.contact.description',
      fields: getContactFieldsForEntity('mandate.'),
    },
  ],
  relatedInLoop: [],
};
